import type { NavHighlightKey } from '@paeffgen/react/crm-documents/ui';

/**
 * Routes that get a „new" highlight when something is added outside their page.
 * Shared by the desktop AppShell sidebar and the MobileBottomNav.
 */
export const HIGHLIGHT_KEY_FOR_ROUTE: Record<string, NavHighlightKey> = {
  '/materialanfrage': 'materialanfrage',
  '/favoriten': 'favoriten',
  '/projekte': 'projekte',
};
